exports = module.exports = require("../../../../../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "._23xiCteorzDBHGwj6MfzFF{color:\"[theme:themePrimary, default:#0078D4]\";font-size:18pt}", ""]);
// Exports
exports.locals = {
	"computerImage": "_23xiCteorzDBHGwj6MfzFF"
};